
    import {Component, Vue} from 'vue-property-decorator'
    import DatePicker from "@/components/DatePicker/index.vue";
    import {DictDataDto, getSyDictDataInfo} from "@/api/commonConfig";
    import {ReturnOrderParamsDTO} from "@/api/shopOrder";

    @Component({
        name: 'ReturnOrderFilter',
        components: { DatePicker }
    })
    export default class ReturnOrderFilter extends Vue {
        showTemp = false

        startTime = ''
        endTime = '' // 结束时间
        // 订货单状态
        returnOrderStatus: string[] = []
        orderStatusList: DictDataDto[] = []
        returnOrderType: null | number = null
        // 退单方式列表
        orderTypeList = [
            { type: null, value: '全部' },
            { type: 1, value: '自主退单' },
            { type: 2, value: '代退单' },
        ]

        created () {
            this.getOrderStatusList()
        }

        getOrderStatusList () {
            getSyDictDataInfo({ dictTypeId: 'returnOrderStatus' }).then((res) => {
                this.orderStatusList = res.data || []
            }).catch(() => {})
        }

        changeOrderStatus (status: string) {
            if (this.returnOrderStatus.includes(status)) {
                const index = this.returnOrderStatus.findIndex((item) => { return item === status })
                this.returnOrderStatus.splice(index, 1)
            } else {
                this.returnOrderStatus.push(status)
            }
        }

        resetFunc () {
            this.startTime = ''
            this.endTime = ''
            this.returnOrderStatus = []
            this.returnOrderType = null
        }

        sureFunc () {
            const params: ReturnOrderParamsDTO = {
                startTime: this.startTime,
                endTime: this.endTime,
                returnOrderStatus: this.returnOrderStatus,
                returnOrderType: this.returnOrderType,
                pageIndex: 1
            }
            this.$emit('getFilterParams', params)
            this.showTemp = false
        }

        show () {
            this.showTemp = true
        }

        getStartTime (val: string) {
            this.startTime = val
        }

        getEndTime (val: string) {
            this.endTime = val
        }


    }
